import React, { useEffect } from 'react'
import Inquiry from '../component/Inquiry';
import { Link } from 'react-router-dom';



export default function Contact() {

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            <section className="pad60 box-shadow innertopbanner innercontact" >
                <div className="container">
                    <div className="row align-items-center height100">
                        <div className="col-lg-6 col-md-12">
                            <div className="banner-caption">
                                <div itemScope="" itemType="http://schema.org/BreadcrumbList" className="breadcrumbs">
                                    <ul>
                                        <li itemProp="itemListElement" itemScope="" itemType="http://schema.org/ListItem">
                                            <Link to="/">
                                                <span itemProp="name">Home</span>
                                            </Link>
                                            <meta itemProp="position" content="1" />
                                        </li>
                                        <li itemProp="itemListElement" itemScope="" itemType="http://schema.org/ListItem">
                                            <i className="icofont-thin-right"></i>
                                            <Link to="/contact#">
                                                <span itemProp="name">Contact Us</span>
                                            </Link>
                                            <meta itemProp="position" content="2" />
                                        </li>
                                    </ul>
                                </div>
                                <h1>Reach out to start your journey with us.</h1>
                                <p>We provide multiple channels to connect with our dedicated Support Team for assistance.</p>
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-12">
                            <div className="banner-mobiles text-center">
                                <img data-perfmatters-preload="" loading="eager" fetchPriority="high" src={require('../assets/images/services/products/data-bg-transparant.webp')} alt="CLOUD MIND banner" className="entered pmloaded" />
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <Inquiry />

            <div className='footer-contact mt-3 bottom'>
                <div className='container'>
                    <div className='row conact_item'>
                        <div className='col-lg-4'>
                            <div className='contact-box'>
                                <div className='img-icons'>
                                    <img src={require('../assets/images/location.png')} alt='Office Location' />
                                </div>
                                <h3>Office Location</h3>
                                <p><a href="https://maps.app.goo.gl/gzY11ESAvLixnPUT9" rel="noopener" target="_blank">38th Floor, Office No: 28, One Business Center, Media One Hotel Tower, Media City, Dubai, PO Box - 10055, UAE.</a></p>
                            </div>
                        </div>
                        <div className='col-lg-4'>
                            <div className='contact-box'>
                                <div className='img-icons'>
                                    <img src={require('../assets/images/call.webp')} alt='Phone' />
                                </div>
                                <h3>Phone No</h3>
                                <p>
                                    <a href="tel:+971564874221">+971-564874221</a><br />
                                    <a href="tel:+971501227432">+971-501227432</a>
                                </p>
                            </div>
                        </div>
                        <div className='col-lg-4'>
                            <div className='contact-box'>
                                <div className='img-icons'>
                                    <img src={require('../assets/images/email.webp')} alt='Email' />
                                </div>
                                <h3>Email Address</h3>
                                <p><a href="mailto:sales@cloudmindme.com">sales@cloudmindme.com</a></p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}
